import { useState, useEffect } from 'react';

import { socket } from 'api';

/**
 * use video urls
 * @param {*} props
 * @returns
 */
export const useRackState = (props) => {
  const { mode, sendControlMsg, id } = props;
  const [state, setState] = useState(null);

  /**
   * get urls from socket
   */
  useEffect(() => {
    const onGetState = (msg) => {
      if (msg.target === id) {
        // if (self._ismounted) {
        setState(msg);
        // }
      }
    };
    socket.on('get_state', onGetState);

    if (mode === undefined) {
      sendControlMsg('get_state');
    }

    const timer1 = setInterval(() => {
      sendControlMsg('get_state_background');
    }, 30000);

    return () => {
      socket.off('get_state', onGetState);
      if (timer1) {
        clearInterval(timer1);
      }
    };
  }, [mode]);

  return { state };
};
